
import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  ref,
  toRefs,
  watch,
} from "vue";
import QrCreator from "qr-creator";
import { useMessengerHeader } from "@/composables/messengerHeader";
import { closeDialog } from "vue3-promise-dialog";
import { useI18n } from "vue-i18n";

export default defineComponent({
  name: "QRModal",
  components: {},
  props: {
    url: {
      type: String,
      required: true,
    },
    text: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const { height: headerHeight, setBackAction } = useMessengerHeader();
    const { url } = toRefs(props);
    const { t } = useI18n();

    const returnValue = () => true;

    const qrCodeContainer = ref<HTMLDivElement>();

    const containerStyle = computed(
      () =>
        `top: ${headerHeight.value}px; height: calc(100% - ${headerHeight.value}px)`
    );

    watch([url, qrCodeContainer], () => {
      if (!qrCodeContainer.value || !url.value) {
        return;
      }

      QrCreator.render(
        {
          text: url.value,
          radius: 0.5, // 0.0 to 0.5
          ecLevel: "H", // L, M, Q, H
          fill: "#504BE5", // foreground color
          background: null, // color or null for transparent
          size: 128, // in pixels
        },
        qrCodeContainer.value
      );
    });

    onMounted(() => {
      setBackAction(() => closeDialog(null));
    });

    onUnmounted(() => {
      setBackAction(null);
    });

    return {
      returnValue,
      qrCodeContainer,
      headerHeight,
      containerStyle,
      t,
    };
  },
});
